<template>
    <v-tooltip right :disabled="!item.tooltip" color="warning">
        <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on">
                <v-list-item
                    :href="href"
                    :rel="href && href !== '#' ? 'noopener' : undefined"
                    :target="href && href !== '#' ? '_blank' : undefined"
                    :to="item.to"
                    class="nav-link"
                    :active-class="`grey ${!$vuetify.theme.dark ? 'lighten-2 black' : 'darken-3 white'}--text`"
                    :disabled="item.disabled"
                >
                    <v-list-item-icon v-if="text" class="v-list-item__icon--text" v-text="computedText" />

                    <v-list-item-icon v-else-if="item.icon">
                        <v-icon v-text="item.icon" :color="item.iconColor" />
                    </v-list-item-icon>

                    <v-list-item-content v-if="item.title || item.subtitle">
                        <v-list-item-title v-text="item.title" />
                        <v-list-item-subtitle v-text="item.subtitle" />
                    </v-list-item-content>

                    <v-list-item-icon v-if="item.newTab">
                        <v-icon color="grey">mdi-open-in-new</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </div>
        </template>
        <span>{{ item.tooltip }}</span>
    </v-tooltip>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";

export default {
    name: "Item",

    mixins: [Themeable],

    props: {
        item: {
            type: Object,
            default: () => ({
                newTab: false,
                href: undefined,
                icon: undefined,
                iconColor: undefined,
                subtitle: undefined,
                title: undefined,
                to: undefined,
                disabled: false,
                tooltip: undefined,
            }),
        },
        text: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        computedText() {
            if (!this.item || !this.item.title) return "";

            let text = "";

            this.item.title.split(" ").forEach((val) => (text += val.substring(0, 1)));

            return text;
        },

        href() {
            return this.item.href || (!this.item.to ? "#" : undefined);
        },
    },
};
</script>
